import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Overlay, Tooltip } from "react-bootstrap"
import styled from "styled-components"

import { useInput } from "client/utils"
import { StoreType } from "client/store"
import { Textarea, Label } from "client/components"


const TableTextareaStyled = styled(Textarea)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    resize: none;
`
const tooltipOffset = "4px"
const TooltipStyled = styled(Tooltip)`
    padding-bottom: ${tooltipOffset};

    & > .tooltip-inner {
        min-width: 200px;
        padding: 6px 12px;
        border-radius: 4px;
        text-align: left;
        line-height: 20px;
        font-family: ${(props) => props.theme.defaultFont};
        font-size: 14px;
        color: ${(props) => props.theme.tooltipColor};
        background: ${(props) => props.theme.tooltipBackground};
    }

    & > .tooltip-arrow {
        position: absolute;
        display: block;
        width: 12px;
        height: 6px;
        top: calc(100% - ${tooltipOffset});

        &::before {
            position: absolute;
            content: "";
            pointer-events: none;
            border: solid 6px transparent;
            border-bottom: none;
            border-top-color: ${(props) => props.theme.tooltipBackground};
        }
    }
`


interface TextareaProps {
    data: string
    dataDefault: string
    onChange: (value: string) => void
    clearActiveCell: () => void
}
let valueSaved = ""

const TableTextarea = ({
    data,
    dataDefault,
    onChange,
    clearActiveCell,
}: TextareaProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    const [value, setValue] = useInput(data || "")
    const [target, setTarget] = useState<HTMLElement>(null)

    useEffect(() => {
        const textarea = document.querySelector(TableTextareaStyled) as HTMLTextAreaElement
        textarea.focus()
        textarea.select()
        setTarget(textarea)

        return () => {
            onChange(valueSaved)
            valueSaved = ""
        }
    }, [])

    useEffect(() => {
        valueSaved = value
    }, [value])

    return (
        <>
            <TableTextareaStyled
                value={value}
                onChange={setValue}
                onKeyDown={(e) => e.key === "Enter" && clearActiveCell()}
                onClick={(e) => e.stopPropagation()}
            />
            <Overlay target={target} show placement="top">
                <TooltipStyled id="translation-helper">
                    <Label>{`${lang.defaultValue}:`}</Label>
                    <div>{dataDefault}</div>
                </TooltipStyled>
            </Overlay>
        </>
    )
}
export default TableTextarea
